import React, { useRef } from 'react';
import { useHeroParticles } from '../hooks/useHeroParticles';
import { useLanguage } from '../i18n/LanguageContext';

const Hero = () => {
  const canvasRef = useRef(null);
  const { t } = useLanguage();
  useHeroParticles(canvasRef);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero">
      <canvas id="heroCanvas" ref={canvasRef} />
      <div className="hero-content">
        <span className="eyebrow">{t.hero.eyebrow}</span>
        <h1>{t.hero.titleBefore}<span className="grad">{t.hero.titleHighlight}</span>{t.hero.titleAfter}</h1>
        <p className="hero-desc">{t.hero.desc}</p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={() => scrollToSection('apps')}>
            {t.hero.primary}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
          <button className="btn-ghost" onClick={() => scrollToSection('sobre')}>{t.hero.secondary}</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
